import React, { useEffect } from 'react'
import { ReactComponent as SVGLogin } from 'assets/svgs/login.svg'
import { ReactComponent as SVGLogout } from 'assets/svgs/logout.svg'
import './style.scss'
import { useDispatch, useSelector } from 'react-redux'
import { selectWallet } from 'store/wallet/selectors'
import { useNavigate } from 'react-router-dom'
import { setAddress } from 'store/wallet/walletSlice'
import { setAccessToken } from 'utils/sendRequest'
import {
  loadEventWallet,
  loadUser,
  loadWallet,
  requestDisconnectDApp,
} from 'wallet/ether'
import { setUser } from 'store/user/storage'
import { setDataUser } from 'store/user/userSlice'

export default function UserConnect() {
  const { address } = useSelector(selectWallet)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  function logout() {
    setAccessToken(undefined)

    setUser(undefined)
    dispatch(setDataUser(undefined))

    dispatch(setAddress(undefined))

    requestDisconnectDApp()

    navigate('/', { replace: true })
  }

  async function loadUserAndWallet() {
    await loadUser(dispatch)
    await loadWallet(dispatch)
    loadEventWallet(dispatch)
  }

  useEffect(() => {
    loadUserAndWallet()
  }, [])

  return (
    <div className='user-connect'>
      {address ? (
        <SVGLogout title='Logout' onClick={logout} />
      ) : (
        <SVGLogin
          title='Login'
          onClick={() => navigate('/', { replace: true })}
        />
      )}
    </div>
  )
}
